import styled from 'styled-components';

import { SelectSize } from '../../theme/Form';
import { rem } from '../../utils';

export const StyledDropdownContainer = styled.div`
  position: absolute;
  width: 100%;
  min-width: 100px;
  z-index: ${({ theme }) => 4 * theme.ZIndex.ZIndex.Modal};
`;

export const StyledDropdownWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Light};
  box-shadow: 0 0 8px 0 ${({ theme }) => theme.Color.Overlay.Light};
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Small)};
  padding: ${({ theme }) => `${rem(theme.Spacing.Size.XXSmall)}`};
  background: ${({ theme }) => theme.Components.Panel.Background};
`;

export const StyledDropdownOptionsContainer = styled.div<{
  $size: keyof typeof SelectSize;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => `${rem(theme.Spacing.Size.XXSmall)}`};
  padding: ${({ theme }) => `${rem(theme.Spacing.Size.XXSmall)}`};
  max-height: ${({ theme, $size }) =>
    `${rem($size ? theme.Form.SelectSize[$size] : theme.Form.SelectSize.Small)}`};
  overflow: auto;
  ${({ theme }) => {
    return theme.Scrollbar.ThinScrollbar;
  }}

  ::-webkit-scrollbar-track {
    margin: ${({ theme }) => `${rem(theme.Spacing.Size.XSmall)}`} 0;
  }
`;

export const StyledDropdownOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => `${rem(theme.Spacing.Size.XSmall)}`};
  user-select: none;
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  height: 40px;
  gap: ${({ theme }) => `${rem(theme.Spacing.Size.XSmall)}`};

  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.Color.Neutrals.Light};
  }
`;
